import request from "@/utils/request";

// 创建评论
export const  createComment =(data) =>{
    return request({
        url: "/businessservice/comment/create",
        method:"post",
        data: data
    })
}

// 删除评论
export const  deleteComment =(query) =>{
    return request({
        url: "/businessservice/comment/delete",
        method:"get",
        params: query
    })
}

// 查询评论列表
export const  listComment =(query) =>{
    return request({
        url: "/businessservice/comment/list",
        method:"get",
        params: query
    })
}